export default "__VITE_ASSET__5hNGwqjC__"